import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';
import { ICONS } from '@/lib/homeLayout';

export default function DesktopQuickLinks({ s, theme }) {
  const items = s.items || [];
  return (
    <section className="py-6 lg:py-10" style={{ background: s.bg_color, fontFamily: theme.body_font }}>
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid gap-3 lg:gap-6 grid-cols-2 lg:[grid-template-columns:repeat(var(--cols),minmax(0,1fr))]" style={{ '--cols': Math.max(items.length, 1) }}>
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || Leaf;
            const external = /^https?:\/\//.test(item.link || '');
            const props = { className: 'group bg-white border p-4 lg:p-8 text-center transition-all duration-300 hover:shadow-lg hover:-translate-y-1', style: { borderColor: theme.accent_color } };
            const body = (
              <>
                <Icon className="w-6 h-6 mx-auto mb-2 lg:mb-4" strokeWidth={1.5} style={{ color: s.text_color || theme.primary_color }} />
                <h3 className="text-base lg:text-xl mb-1 lg:mb-2 font-bold text-black" style={{ fontFamily: theme.heading_font }}>{item.title}</h3>
                <p className={`text-xs lg:text-sm leading-snug ${s.text_color ? '' : 'text-brand-gray'}`} style={{ color: s.text_color || undefined }}>{item.text}</p>
              </>
            );
            return external
              ? <a key={i} href={item.link} {...props}>{body}</a>
              : <Link key={i} to={item.link || '/'} {...props}>{body}</Link>;
          })}
        </div>
      </div>
    </section>
  );
}